module.exports = __webpack_public_path__ + "fonts/fa-brands-400.89a52ae.eot";